module.exports = __webpack_public_path__ + "img/CRT_Weapon-Fan-02.e5834f20.png";